import React, { useState, useEffect } from "react";
import "./ThemeToggle.css";

// Icons
import iconM from "../Img/Nav_Icons/moon.png";
import iconS from "../Img/Nav_Icons/sun.png";

const ThemeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage for saved theme preference, default to dark
    const savedTheme = localStorage.getItem("theme");
    return savedTheme ? savedTheme === "dark" : true;
  });

  // Apply theme to document root
  useEffect(() => {
    const root = document.documentElement;
    if (isDarkMode) {
      root.setAttribute("data-theme", "dark");
    } else {
      root.setAttribute("data-theme", "light");
    }
    // Save preference to localStorage
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    // Dark mode toggle
    <div className="theme_toggle">
      < button
        onClick={toggleTheme}
        className="theme_toggle-btn"
        aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
        title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
      >
        <img
          src={isDarkMode ? iconM : iconS}
          alt={isDarkMode ? "Moon icon" : "Sun icon"}
        />
      </button>
    </div>
  );
};

export default ThemeToggle;
